<template>
  <div class="cmp-like">
    <i class="cmp-icon-like" :class="['cmp-icon-like', isMyLike ? 'active' : '']" @click.stop="changeLike"></i>
    <span class="ml-10" v-if="showTxt">{{loveNum}}人收藏</span>
  </div>
</template>

<script>
// import { Toast } from 'mint-ui';
export default {
  name: 'myCmpLike',
  props: {
    isLike: {
      type: Boolean,
      default: false
    },
    likeId: {
      type: String,
      default: ''
    },
    showTxt: {
      type: Boolean,
      default: false
    },
    num: {
      type: Number,
      default: 0
    },
    // 其他入参
    type: {
      type: String,
      default: '1'
    },
    // 成功回调
    callback: Function  
  },
  data() {
    return {
      isMyLike: this.isLike,
      loveNum: 0
    }
  },
  watch:{
    num: {
      handler(newVal) {
        this.loveNum = newVal
      },
      immediate: true
    },
    isLike(newVal) {
      this.isMyLike = newVal
    }
  },
  methods: {
    changeLike() {
      // 接口联调时打开
      this.addLike()
    },
    // 添加/取消收藏
    addLike() {
      if(!this.$store.state.user.userid) {
        this.$common.showConfirmLogin()
        return
      }
      let api = this.isMyLike ? '/m/myInfo/delCollect.do' : '/m/myInfo/addCollect.do'
      this.$http.get(api, {
        userId: this.$store.state.user.userid,
        token: this.$store.state.user.token,
        collectID: this.likeId,
        type: this.type,   // 收藏类型： 1：藏品 
      }).then((res) => {
        if(res.success === 1) {
          if(!this.callback) {
            this.isMyLike = !this.isMyLike
            this.$message.success(this.isMyLike?'添加收藏成功':'取消收藏成功')
          } else {
            this.callback(this.likeId)  // 删除
            this.$message.success('取消收藏成功')
          }
          this.loveNum = res.data
        } else {
          this.$message.error(this.isMyLike?'取消收藏失败':'添加收藏失败')
        }
      })
    }
  },
  mounted() {
    
  },
  activated() {
  }
}
</script>

<style lang="scss" scoped>
.cmp-icon-like {
	display: inline-block;
  width: 20px;
  height: 19px;
	background: url('~@images/shoucang.png') center center no-repeat;
	background-size: 100% 100%;
  // margin-right: 5px;
}

.cmp-icon-like.active {
  background: url('~@images/shoucang_2.png') center center no-repeat;
  background-size: 100% 100%;
}

.cmp-like {
  position: absolute;
  top: 6px;
  right: 20px;
	z-index: 2;
  display: flex;
  align-items: center;
  &.light {
    .cmp-icon-like {
      background: url('~@images/icon_like.png') center center no-repeat;
      background-size: 100% 100%;
    }
    .cmp-icon-like.active {
      background: url('~@images/icon_like_active.png') center center no-repeat;
      background-size: 100% 100%;
    }
  }
}
</style>
